import { Component, OnInit } from '@angular/core';
import { DataBridgeService } from '../../../services/data-bridge.service';
import { NetworkService } from '../../../services/network.service';

@Component({
  selector: 'app-admin-viewer',
  templateUrl: './admin-viewer.component.html',
  styleUrls: ['./admin-viewer.component.scss']
})
export class AdminViewerComponent implements OnInit {
  offices: Object;
  shouldShowFloors: boolean = false;
  floors: Object;
  selectedOffice: any;
  selectedFloor: any;
  layout: any;
  isDataReady: boolean = false;
  seatList: any;
  selectedSeat: HTMLElement;
  shouldShowLoader2 = false;
  filter: any;
  changeOn: string;

  constructor(private _network: NetworkService, private _dataBridge: DataBridgeService) { }

  ngOnInit(): void {
    this._network.getOffices().subscribe((res) => {
      this.offices = res['offices']
      this.officeSelected({ target: { value: this.offices[0].guid } })
    });

  }

  officeSelected(event) {
    this.selectedOffice = event.target.value;
    this._network.getFloors(this.selectedOffice).subscribe((res) => {
      this.shouldShowFloors = true;
      this.floors = res;
      this.floorSelected({ target: { value: this.floors[0]._id } })
    })
  }

  floorSelected(event) {
    this.isDataReady = false;
    this.selectedFloor = event.target.value;
    this._network.getLayoutForFloor(this.selectedFloor, this.selectedOffice).subscribe(res => {
      if (res[0].floor.floortype == "WITH_BACKGROUND_IMAGE") {
        let path = JSON.parse(res[0].floor.extras).backgroundImagePath
        this._network.getFloorImage(path.split('/')[0], path.split('/')[1]).subscribe((image) => {
          this.layout = {'planDetails': res[0], 'image':image};
          this.isDataReady = true;
        });
      } else {
        this.layout = {'planDetails': res[0], 'image':null};
        this.isDataReady = true;
      }
    });
  }

  isFloorRendered(event){
    this.seatList = this._dataBridge.getSeatsList();
  }

  seatSelected(event) {
    this.shouldShowLoader2 = true;
    this.changeOn = "search"
    this.selectedSeat = this.seatList[event.target.value]
    setTimeout(() => {
      this.shouldShowLoader2 = false;
    }, 1200)
  }

  setFilter(event) {
    this.changeOn = "filter"
    this.filter = event.target.value
  }

}
